/**
 * The single booking link for the conversion suite. Every surface that offers
 * "book a call" — the merchant-app schedule-demo flow and the merchant-email
 * outreach campaigns — resolves the URL from here so the destination can be
 * repointed in one place. Do not inline the URL anywhere else.
 */
const CHOP_XSELL_SCHEDULE_DEMO_DESTINATION_URL =
  "https://calendar.app.google/uu6mNCBYvdcFTfuF9";

export function getScheduleDemoDestinationUrl() {
  return CHOP_XSELL_SCHEDULE_DEMO_DESTINATION_URL;
}
